<template>
  <div :class="{ 'floating-button--disabled': disabled }" class="floating-button">
    <button v-if="clearable"
            :aria-label="clearLabel"
            :title="clearLabel"
            class="floating-button__clear"
            type="button"
            @click.stop="$emit('clear', $event)"
    >
      <span aria-hidden="true">&#10005;</span>
    </button>
    <button :disabled="disabled" class="floating-button__main" @click="$emit('click', $event)">
      <slot></slot>
    </button>
  </div>
</template>

<script>

export default {
  name: 'ButtonFloating',
  components: { },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    // shows a separate clear segment on the left of the pill; it stays
    // clickable even when the main action is disabled
    clearable: {
      type: Boolean,
      default: false,
    },
    clearLabel: {
      type: String,
      default: null,
    },
  },

  data: function () {
    return {

    };
  },

  computed: {

  },

  watch: {

  },

  created: function () {

  },

  mounted: function () {
    this.mounted = true;
  },

  methods: {

  },
};
</script>

<style lang="scss">
  @import '~@/styles/import';
  .floating-button {
    @apply fixed bottom-16 left-16 h-64 w-full flex items-stretch bg-primary z-50 rounded-32 overflow-hidden;
      max-width: calc(100% - 3.2rem);
    @media (min-width: 768px) {
      @apply fixed left-460;
      width: calc(100% - 460px - 64px);
      max-width: 57.2rem;
    }

    &--disabled {
      @apply bg-grayBlue;
    }

    &__clear {
      @apply flex items-center justify-center text-white text-16 font-semibold cursor-pointer;
      background: transparent;
      border-right: 1px solid rgba(255, 255, 255, 0.4);
      // slightly more padding on the left: next to the rounded pill edge a
      // mathematically centered glyph looks shifted towards the corner
      padding: 0 2.2rem 0 2.6rem;
    }

    &__main {
      @apply flex items-center justify-center px-30 py-22 text-white font-semibold;
      flex: 1 1 0%;
      background: transparent;

      &:disabled {
        @apply cursor-not-allowed;
      }
    }
  }
</style>
